import { useMemo } from 'react';
import { useClock } from '../store/clock-store';

const BLINK_THRESHOLD_SECONDS = 10 * 60;

export interface ElapsedTime {
    elapsed: number;       // negativni = odpocet, pozitivni = po limitu (total time od vyhlaseni)
    formatted: string;     // "-MM:SS" nebo "+MM:SS"
    shouldBlink: boolean;  // elapsed >= 10 min (total time od vyhlaseni)
}

export const useElapsedTime = (casVyhlaseni: string, casVyjezdMinuty: number): ElapsedTime => {
    const now = useClock();
    return useMemo(() => {
        const limitSeconds = casVyjezdMinuty * 60;
        const vyhlaseniTime = new Date(casVyhlaseni).getTime();
        const secondsSince = Math.floor((now.getTime() - vyhlaseniTime) / 1000);

        // pred limitem: zaporne sekundy (odpocet do limitu)
        // po limitu: kladne sekundy (total time od vyhlaseni)
        let elapsed: number;
        if (secondsSince < limitSeconds) {
            elapsed = secondsSince - limitSeconds; // zaporne: odpocet do limitu
        } else {
            elapsed = secondsSince; // kladne: total time od vyhlaseni
        }

        const sign = elapsed < 0 ? '-' : '+';
        const abs = Math.abs(elapsed);
        const mins = Math.floor(abs / 60);
        const secs = abs % 60;
        const formatted = `${sign}${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

        return {
            elapsed,
            formatted,
            shouldBlink: elapsed >= BLINK_THRESHOLD_SECONDS,
        };
    }, [now, casVyhlaseni, casVyjezdMinuty]);
};
